import React, { useState, useEffect } from "react";
import {
  Nav,
  Button,
  Offcanvas,
  Spinner,
  Container,
} from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { logout } from "../../../features/auth/authActions";
import Api from "../../components/api/Api";
import AdminHeader from "../../common/Header";
import { isAdminUser } from "../../navigation/adminNavigation";
import {
  FaUser,
  FaUserEdit,
  FaFileUpload,
  FaCreditCard,
  FaSignOutAlt,
  FaBars,
} from "react-icons/fa";
import Style from "../../UserStyle.module.css";
import "./UserProfile.css";

const UserProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const authState = useSelector((state) => state.auth);
  const loggedInUser = authState.user;
  const userId = loggedInUser?.userDetails?.id;
  const adminUser = isAdminUser(authState);

  const [userDetail, setUserDetails] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showSidebar, setShowSidebar] = useState(false);

  const logoutHandler = async () => {
    try {
      dispatch(logout());
      navigate("/login");
    } catch (error) {
      console.log(error);
    }
  };

  const getDetailsApi = Api({
    url: `admin/user/id/${userId}`,
  });

  useEffect(() => {
    const fetchData = async () => {
      if (adminUser) {
        return;
      }

      try {
        setIsLoading(true);
        const responseData = await getDetailsApi.fetchData();
        setUserDetails(responseData?.data?.user);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();

    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [adminUser]);

  const navItems = [
    { label: "Profile", path: "/user/profile", icon: <FaUser /> },
    { label: "Edit Profile", path: "/user/edit-profile", icon: <FaUserEdit /> },
    // { label: "Change Password", path: `/changepassword/${userId}`, icon: <FaLock /> },
    { label: "Documents", path: `/user/upload-documents`, icon: <FaFileUpload /> },
    { label: "Payment", path: `/user/payment-details`, icon: <FaCreditCard /> },
    { label: "Logout", action: logoutHandler, icon: <FaSignOutAlt />, color: "red" },
  ];

  const renderSidebar = () => (
    <nav className="sidebar-container-modern">
<Nav className="flex-column w-100 px-3 py-3">
  {navItems.map((item, idx) => {
    const isActive = location.pathname === item.path;

    return (
      <Nav.Item key={idx} className="mb-1">
        
        {/* NORMAL LINK */}
        {item.path ? (
          <Nav.Link
            as={Link}
            to={item.path}
            className={`sidebar-link-modern d-flex align-items-center justify-content-start gap-3 ${
              isActive ? "active" : ""
            }`}
          >
            <span className="sidebar-icon-modern">{item.icon}</span>
            <span className="sidebar-label-modern">{item.label}</span>
          </Nav.Link>
        ) : (
          
          /* LOGOUT OR ACTION BUTTON */
          <Nav.Link
            onClick={item.action}
            className="sidebar-link-modern d-flex align-items-center justify-content-start gap-3"
          >
            <span className="sidebar-icon-modern text-danger">{item.icon}</span>
            <span className="sidebar-label-modern text-danger">{item.label}</span>
          </Nav.Link>

        )}
      </Nav.Item>
    );
  })}
</Nav>

    </nav>
  );

  if (adminUser) {
    return <AdminHeader />;
  }

  return (
    <>
      {isLoading ? (
        <div className={Style.spinner}>
          <Spinner animation="border" role="status">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        </div>
      ) : (
        <Container fluid className="p-3">
          {/* Mobile Toggle */}
          {isMobile && (
            <Button
              variant="light"
              className="mb-3 d-flex align-items-center gap-2"
              onClick={() => setShowSidebar(true)}
            >
              <FaBars />
            </Button>
          )}

          {/* Desktop Sidebar */}
          {!isMobile && renderSidebar()}

          {/* Mobile Offcanvas */}
          {isMobile && (
            <Offcanvas
              show={showSidebar}
              onHide={() => setShowSidebar(false)}
              placement="start"
            >
              <Offcanvas.Header closeButton>
              </Offcanvas.Header>
              <Offcanvas.Body>{renderSidebar()}</Offcanvas.Body>
            </Offcanvas>
          )}
        </Container>
      )}
    </>
  );
};

export default UserProfile;
